import React, {useState} from 'react';
import {
    Delete,
    EmergencyRecording,
    EmergencyRecordingOutlined,
    EmergencyRecordingRounded,
    EmergencyRecordingTwoTone,
    FiberManualRecord,
    FiberSmartRecord,
    LinkedCamera,
    MissedVideoCall,
    MusicVideo,
    OndemandVideo,
    PersonalVideo,
    SettingsInputSvideo,
    SlowMotionVideo,
    SwitchVideo, Videocam,
    VideoCameraBack,
    VideoCameraFront,
    VideoChat, VideoLabel, VideoLibrary, VideoStable
} from '@mui/icons-material';
import {CircularProgress, IconButton} from '@mui/material';
import {Box, Button, AppBar, Toolbar, Grid, Typography, Modal, LinearProgress, TextField} from '@mui/material';
import {
    Add, Edit
} from '@mui/icons-material';
import ConfirmEmailMessage from "./ConfirmEmailMessage";
import RecordingEditor from "./RecordingEditor";
import {
    closestCenter,
    DndContext,
    DragEndEvent,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors
} from "@dnd-kit/core";
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    useSortable,
    verticalListSortingStrategy
} from "@dnd-kit/sortable";
import {CSS} from '@dnd-kit/utilities';
import {stopPropagation} from "@dnd-kit/core/dist/sensors/events";

import {Slide, Visit} from '../services/types'
import {generateVisitVideo} from "../services/api";

// interface VisitSlide {
//     id: string;
//     slide: Slide;
// }

// interface Visit {
//     id: string;
//     name: string;
//     project_id: string;
//     sort: number;
//     external_id?: string;
//     slides: VisitSlide[];
// }

interface VisitBoxProps {
    visit: Visit;
    onAddSlide: (visitId: number) => void;
    onEditName: (visitId: number, visitName: string) => void;
    onDeleteVisit: (visitId: number) => void;
    onReorderSlides: (visitId: number, newOrder: number[]) => void;
    onDeleteSlide: (visitId: number, visitSlideId: number) => void;
    onEditSlide: (visitSlideId: number) => void;
}
interface SortableSlideItemProps {
    slide: Slide;
    onDelete: (visitSlideId: number) => void;
    onEdit: (visitSlideId: number) => void;
}
const VisitBox: React.FC<VisitBoxProps> = ({visit, onAddSlide, onEditName, onDeleteVisit, onReorderSlides, onDeleteSlide, onEditSlide}) => {
    const [isDragging, setIsDragging] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [recordingVisitId, setRecordingVisitId] = useState(0);
    const [recordingVisitSlides, setRecordingVisitSlides] = useState<Slide[]>([]);

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );


    const handleDragMove = (event: DragEndEvent) => {
        setIsDragging(true);
    };
    const handleDragEnd = (event: DragEndEvent) => {
        setIsDragging(false);

        const {active, over} = event;
        if (over && active.id !== over.id) {
            const oldIndex = visit.slides.findIndex((slide) => slide.id === active.id);
            const newIndex = visit.slides.findIndex((slide) => slide.id === over.id);
            const newOrder = arrayMove(visit.slides, oldIndex, newIndex);
            onReorderSlides(visit.id, newOrder.map(slide => slide.id));
            // console.log(newOrder)
        }
    };

    const openRecordModal = async (visitId: number, slides: Slide[]) => {
        setRecordingVisitId(visitId)
        setRecordingVisitSlides(slides)
        setIsRecording(true)

        const response = await generateVisitVideo(visitId)
        console.log(response)
        setIsRecording(false)
    };
    const closeRecording = () => {
        setRecordingVisitId(0)
        setRecordingVisitSlides([])
        setIsRecording(false)
    };


    const SortableSlideItem: React.FC<SortableSlideItemProps> = ({ slide, onDelete, onEdit }) => {
        const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: slide.id });


        const style = {
            transform: CSS.Transform.toString(transform),
            transition,
        };
        const handleDelete = (e: React.MouseEvent) => {
            e.stopPropagation();
            if (!isDragging) {
                onDelete(slide.id);
            }
        };
        const handleEdit = (e: React.MouseEvent) => {
            e.stopPropagation();
            if (!isDragging) {
                onEdit(slide.id);
            }
        };
        return (
            <Box
                ref={setNodeRef}
                style={style}
                {...attributes}
                {...listeners}
                className='visitSlideItem'
                sx={{
                    position: 'relative',
                    '&:hover .editButton': {opacity: 1},
                    '&:hover .deleteButton': {opacity: 1}
                }}
            >
                <img src={'https://stage.selfdetailing.ru'+slide.picture.raw} alt={slide.picture.raw} style={{maxHeight: '256px', objectFit:'cover', width:'100%'}}/>

                <IconButton
                    className="editButton"
                    sx={{
                        position: 'absolute',
                        top: 5,
                        right: 55,
                        opacity: 0,
                        transition: 'opacity 0.2s',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        '&:hover': {backgroundColor: 'rgba(255, 255, 255, 0.9)'}
                    }}
                    onMouseDown={(e) => e.stopPropagation()}
                    onMouseUp={(e) => {e.stopPropagation(); handleEdit(e);}}
                    // onClick={handleDelete}
                >
                    <Edit/>
                </IconButton>
                <IconButton
                    className="deleteButton"
                    sx={{
                        position: 'absolute',
                        top: 5,
                        right: 5,
                        opacity: 0,
                        transition: 'opacity 0.2s',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        '&:hover': {backgroundColor: 'rgba(255, 255, 255, 0.9)'}
                    }}
                    onMouseDown={(e) => e.stopPropagation()}
                    onMouseUp={(e) => {e.stopPropagation(); handleDelete(e);}}
                    // onClick={handleDelete}
                >
                    <Delete/>
                </IconButton>
            </Box>
        );
    };

    return (

        <>
            <Box mb={4} sx={{pr: '12px'}}>
                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1}}>
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                        <Typography variant="h6">{visit.title}</Typography>
                        <Button sx={{color: '#3a485b', display: 'flex', gap: '4px', ml: 2}} onClick={() => onEditName(visit.id, visit.title)}>
                            <Edit/>
                        </Button>
                        {visit.slides.length == 0 ?
                            <Button sx={{color: '#3a485b', display: 'flex', gap: '4px'}} onClick={() => onDeleteVisit(visit.id)}>
                                <Delete/>
                            </Button>
                            : null
                        }
                    </Box>
                    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1}}>
                        <Button sx={{color: '#3a485b', display: 'flex', gap: '4px', ml: 2}} onClick={() => openRecordModal(visit.id, visit.slides)}>
                            <Videocam/> Записать видео
                        </Button>

                        <Button sx={{color: '#3a485b', display: 'flex', gap: '4px'}} onClick={() => onAddSlide(visit.id)}>
                            <Add/> Добавить слайд
                        </Button>
                    </Box>
                </Box>
                <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd} onDragMove={handleDragMove}>
                    <SortableContext items={visit.slides.map(slide => slide.id)} strategy={verticalListSortingStrategy}>
                        <Box className='visitSlideItems'>
                            {visit.slides.map((slideitem) => (
                                <SortableSlideItem key={slideitem.id} slide={slideitem} onDelete={() => onDeleteSlide(visit.id, slideitem.id)} onEdit={() => onEditSlide(slideitem.id)} />
                            ))}
                        </Box>
                    </SortableContext>
                </DndContext>
            </Box>


            {isRecording && (
                <Modal open={isRecording} onClose={() => closeRecording()}>
                    <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                        <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Typography sx={{mb: 3}}>Пожалуйста, дождитесь завершения генерации</Typography>
                                <CircularProgress/>
                            </Box>
                        </Box>
                    </Box>
                </Modal>
            )}
        </>

    );
};
export default VisitBox;
